(function() {

    var productVariantsSliders = '.js-product-variants-slider';
    var $productVariantsSliders = $(productVariantsSliders);

    var dotSliders = '.js-dot-slider';
    var $dotSliders = $(dotSliders);

    var leftAlignedSlides = '.js-left-aligned-slides';
    var $leftAlignedSlides = $(leftAlignedSlides);

    var centerAlignedSlides = '.js-center-aligned-slides';
    var $centerAlignedSlides = $(centerAlignedSlides);

    var params = {
        counterClass: 'js-slider-counter',
        currentCounterClass: 'js-slider-counter__current',
        totalCounterClass: 'js-slider-counter__total',
        counterSeparator: '/',
        thumbnailsListClass: 'js-slider-thumbnails',
        thumbnailItemClass: 'js-slider-thumbnails__item',
        thumbnailClass: 'js-slider-thumbnails__img',
        slideIndex: 'slide-index',
        dataAttrShortest: 'shortest-slide-height-on-load',
        dataAttrRatio: 'ratio',
        dotSliderSlides: '.js-dot-slider__slide',
        leftAlignedSlidesClass: '.js-left-aligned-slides__slide',
        centerAlignedSlidesClass: '.js-center-aligned-slides__slide',
        sliderMaxHeight: 0.7 // 70vh
    };

    var sliders = [
        {
            sliderType: $productVariantsSliders,
            sameHeight: false,
            slidesClass: false,
            sliderOptions: {
                arrows: true,
                infinite: true,
                waitForAnimate: false
            },
            callback: function() {
                createSlidesCounter( $productVariantsSliders );
                createSlideThumbnails( $productVariantsSliders );
            },
            customEvents: ['lightboxPrev', 'lightboxNext']
        }, {
            sliderType: $dotSliders,
            sameHeight: true,
            slidesClass: params.dotSliderSlides,
            sliderOptions: {
                arrows: false,
                dots: true,
                variableWidth: true,
                centerMode: true,
            }
        }, {
            sliderType: $leftAlignedSlides,
            sameHeight: true,
            slidesClass: params.leftAlignedSlidesClass,
            sliderOptions: {
                arrows: false,
                dots: false,
                variableWidth: true,
                // centerMode: true,
                // basedigitalCustomAlignment: true
                infinite: false,
                cssEase: _easings.easeOutExpo,
                speed: 400
            }
        }, {
            sliderType: $centerAlignedSlides,
            sameHeight: true,
            slidesClass: params.centerAlignedSlidesClass,
            sliderOptions: {
                arrows: false,
                dots: false,
                variableWidth: true,
                centerMode: true,
                infinite: false,
                cssEase: _easings.easeOutExpo,
                speed: 400
            }
        }
    ];

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `createSlidesCounter`
     *
     * Create a custom slides counter so that the user knows how many
     * slides there are.
     *
     * @param `$typeOfSlider` (obj) - a collection of sliders of the same type
     */
    function createSlidesCounter( $typeOfSlider ) {
        var counter = '<div class="c-product-detail__counter '+params.counterClass+'"><span class="'+
            params.currentCounterClass+'">1</span>'+params.counterSeparator+
            '<span class="'+params.totalCounterClass+'"></span>';
        var $counter = $(counter);
        $typeOfSlider.each(function(i, slider) {
            var $slider = $(slider);
            $slider.prepend($counter);
            var count = $slider.find('.slick-slide').not('.slick-cloned').length;
            $slider.find('.'+params.totalCounterClass).text(count);
        });
    }

    /**
     * @function `updateCounter`
     *
     * @param $slider (node) - the slider
     * @param slideIndex (int) - the index of the current slide (from 0)
     */
    function updateCounter( $slider, slideIndex ) {
        var $currentSlideCounter = $slider.find('.'+params.currentCounterClass);
        $currentSlideCounter.text(slideIndex+1);
    }

    /**
     * @function `createSlideThumbnails`
     *
     * Create thumbnails of all the slides. We can use the same size of images
     * used for the slides (they're already there) and we will scale them down
     * using CSS.
     *
     * @param `$typeOfSlider` (obj) - a collection of sliders of the same type
     */
    function createSlideThumbnails( $typeOfSlider ) {
        var thumbnailsList = '<ul class="'+params.thumbnailsListClass+'"></ul>';
        var $thumbnailsList = $(thumbnailsList);
        $typeOfSlider.each(function(i, slider) {
            var $slider = $(slider);
            var $slides = $slider.find('.slick-slide').not('.slick-cloned');
            $slider.append($thumbnailsList);
            for (var s = 0; s < $slides.length; s++) {
                var originalImgSrc = $slides.eq(s).find('img').attr('src');
                var img = '<img class="'+params.thumbnailClass+'" src="'+originalImgSrc+'">';
                var thumbnail = '<li class="'+params.thumbnailItemClass+
                    '" data-'+params.slideIndex+'="'+s+'">'+img+'</li>';
                var $thumbnail = $(thumbnail);
                $slider.find('.'+params.thumbnailsListClass).append($thumbnail);
            }
        });
    }

    /**
     * @function `goToSlide`
     *
     * @param `$thumbnailItem` (node) - the clicked thumbnail `li`
     * @param `dataSlideIndex` (str) - the data attribute storing the slide index
     */
    function goToSlide( $thumbnailItem, dataSlideIndex ) {
        if( typeof dataSlideIndex == 'undefined' ) {
            dataSlideIndex = params.slideIndex;
        }
        var index = $thumbnailItem.data(dataSlideIndex);
        var $slider = $thumbnailItem.closest('.slick-slider').eq(0);
        $slider.slick('slickGoTo', index);
    }

    /**
     * @function `sameHeightSlides`
     *
     * Force all slides included in a slider to be scaled down to the height of
     * the shortest slide.
     *
     * 1. Reset height (useful when the function is run again).
     * 2. Loop through all slides to know which one is the shortest and what is
     *    its height.
     * 3. Save the height of the shortest slide.
     * 4. Save the image ratio of the short slide (= all slides).
     * 5. Will the widest slide fit the screen and leave room for the next one?
     *
     * @param $sliderType (node) - the slider(s)
     * @param slidesClass (str) - the `.class` applied to the slides
     * @param onResize (bool) - the function runs after a resize event
     */
    function sameHeightSlides( $sliderType, slidesClass, onResize ) {
        $sliderType.each(function(i, slider) {
            var cpt = 0;
            var $slider = $(slider);
            var $slides = $slider.find(slidesClass);
            var nbSlides = $slides.length/2;

            $slides.css('height', ''); /* [1] */

            var shortestSlideIndex = 0;
            var shortestSlideHeight = $slides.eq(0).outerHeight();
            var shortestSlideWidth = $slides.eq(0).outerWidth();
            var shortestSlideImageRatio = shortestSlideWidth / shortestSlideHeight;
            var widestSlideIndex = 0;
            var widestSlideImageRatio = shortestSlideImageRatio;

            $slides.each(function(i, slide) { /* [2] */
                var $slide = $(slide);
                var slideHeight = $slide.outerHeight();
                var slideWidth = $slide.outerWidth();
                var slideImageRatio = slideWidth / slideHeight;

                if( slideHeight < shortestSlideHeight ) {
                    shortestSlideIndex = i;
                    shortestSlideHeight = slideHeight;
                    shortestSlideImageRatio = slideImageRatio;
                }

                if( slideImageRatio > widestSlideImageRatio ) {
                    widestSlideIndex = i;
                    widestSlideImageRatio = slideImageRatio;
                }
            });

            shortestSlideHeight = Math.floor(shortestSlideHeight);

            $slider.attr('data-'+params.dataAttrShortest,
                shortestSlideHeight); /* [3] */
            $slider.attr('data-'+params.dataAttrRatio,
                shortestSlideImageRatio); /* [4] */

            var widestSlideResultingWidth = shortestSlideHeight * widestSlideImageRatio;
            var targetWidth = _window_width - 18 * 3;
            if( widestSlideResultingWidth > targetWidth ) { /* [5] */
                var newHeight = Math.floor(targetWidth / widestSlideImageRatio);
                $slides.css('height', newHeight+'px');
            }
            else {
                $slides.css('height', shortestSlideHeight+'px');
            }

            if( onResize ) {
                var $currentSlide = $slider.find('.slick-current');
                var currentSlideIndex = $slides.index($currentSlide);
                $slider.slick('slickGoTo', currentSlideIndex);
            }
        });
    }

    /**
     * @function `initSliders`
     *
     * Init all types of sliders.
     *
     * 1. Fixes issue on Safari where no slide had focus on page load.
     */
    function initSliders( sliderTypesArr ) {
        var sliderTypesCount = sliderTypesArr.length;

        if( !sliderTypesCount ) {
            return;
        }

        for (var i = 0; i < sliderTypesCount; i++) {
            var sliderObj = sliderTypesArr[i];
            if( sliderObj.sliderType.length ) {

                if( sliderObj.sameHeight ) {
                    sameHeightSlides( sliderObj.sliderType, sliderObj.slidesClass, false );
                }

                sliderObj.slickInstance = sliderObj.sliderType.slick(sliderObj.sliderOptions);
                sliderObj.slickInstance.slick('slickGoTo', 0); /* [1] */

                if( sliderObj.callback !== 'undefined' && typeof sliderObj.callback === 'function' ) {
                    sliderObj.callback();
                }
            }
        }
    }

    /**
     * @function `viewportFitDotSliders`
     *
     * Scales down/up the sliders to match the CSS `vh` max height.
     *
     * 1. The height to set to the slider and its slides should be the height of
     *    the slider itself but we will need to keep the image ratio the same.
     * 2. If the height of the slider is taller than its width devided by the
     *    image ratio, we'll use the latter as height.
     * 3. Otherwise (all cases)
     * 4. If it's possible to make the slides (and the slider) taller, we'll
     *    do so.
     * 5. Make sure the slides follow the same height as the slider.
     * 6. As the slides get resized, make sure the slider keeps the proper
     *    translate position.
     */
    function viewportFitDotSliders() {
        $dotSliders.each(function(i, slider) {
            var $slider = $(slider);
            var sliderHeight = Math.floor($slider.outerHeight());
            var sliderWidth = Math.floor($slider.outerWidth());
            var sliderRatio = $slider.data(params.dataAttrRatio);
            var $slides = $slider.find(params.dotSliderSlides);
            var sliderMaxHeight = Math.floor(params.sliderMaxHeight * _$window.outerHeight());
            var shortestSlideHeightOnLoad = $slider.data(params.dataAttrShortest);
            var heightToSet = sliderHeight; /* [1] */
            if( heightToSet > sliderWidth / sliderRatio ) { /* [2] */
                heightToSet = sliderWidth / sliderRatio;
            }
            else { /* [3] */
                if( sliderWidth/sliderRatio < sliderMaxHeight ) { /* [4] */
                    heightToSet = sliderWidth/sliderRatio;
                }
            }
            $slides.css('height', heightToSet+'px'); /* [5] */
            $slider.slick('setPosition'); /* [6] */
        });
    }

    /**
     * @function `viewportFitLeftAlignedSlides`
     *
     * Adapts "same height" of slides so that they scale up/down.
     */
    function viewportFitLeftAlignedSlides() {
        sameHeightSlides( $leftAlignedSlides, params.leftAlignedSlidesClass, true );
    }

    /**
     * @function `viewportFitLeftAlignedSlides`
     *
     * Adapts "same height" of slides so that they scale up/down.
     */
    function viewportFitCenterAlignedSlides() {
        sameHeightSlides( $centerAlignedSlides, params.centerAlignedSlidesClass, true );
    }

    /**
     * @function `viewportUnitsFix`
     *
     * Removes scrollbar width of `100vw`.
     */
    function viewportUnitsFix() {
        var $scrollbar = $('<div class="js-scrollbar-measure">');
        _$body.append($scrollbar);
        $scrollbar = _$document.find('.js-scrollbar-measure');
        var scrollbarWidth = $scrollbar[0].offsetWidth - $scrollbar[0].clientWidth;
        if( !scrollbarWidth ) {
            return;
        }
        $centerAlignedSlides.css('width', 'calc(100vw - '+scrollbarWidth+'px)');
        $leftAlignedSlides.css('width', 'calc(100vw - '+scrollbarWidth+'px)');
        $scrollbar.remove();
    }

    //	======================================================================  //
    //	On ready
    //	======================================================================  //

    $(window).on('load', function() {
        initSliders(sliders);
        viewportUnitsFix();
    });

    //	======================================================================  //
    //	On change
    //	======================================================================  //

    $productVariantsSliders.on('beforeChange', function(e, slick,
        currentSlide, nextSlide) {
        updateCounter( $(this), nextSlide );
    });

    //	======================================================================  //
    //	When clicking on JS-created thumbnails
    //	======================================================================  //

    _$document.on('click', '.'+params.thumbnailItemClass, function() {
        goToSlide( $(this) );
    });

    // ====================================================================== //
    // When clicking on any slide
    // ====================================================================== //

    _$document.on('click', '.slick-slide', function() {
        var $this = $(this);
        if( !$this.hasClass('slick-current') ) {
            goToSlide( $this, 'slick-index' );
        }
    });

    //	======================================================================  //
    //	On resize
    //	======================================================================  //

    onResize.callbacks.dotSliders = function() {
        viewportFitDotSliders();
        viewportFitLeftAlignedSlides();
        viewportFitCenterAlignedSlides();
    };

    // ====================================================================== //
    // Custom Events
    // ====================================================================== //

    window.addEventListener('lightboxPrev', function () {
        for (var i = 0; i < sliders.length; i++) {
            if( sliders[i].customEvents !== 'undefined' && typeof sliders[i].customEvents === 'object' ) {
                if ( sliders[i].customEvents.indexOf('lightboxPrev') > -1 ) {
                    sliders[i].slickInstance.slick('slickPrev');
                }
            }
        }
    });

    window.addEventListener('lightboxNext', function () {
        for (var i = 0; i < sliders.length; i++) {
            if( sliders[i].customEvents !== 'undefined' && typeof sliders[i].customEvents === 'object' ) {
                if ( sliders[i].customEvents.indexOf('lightboxNext') > -1 ) {
                    sliders[i].slickInstance.slick('slickNext');
                }
            }
        }
    });

})();
